function normalizeUrl(url: string | undefined | null): string | null {
	if (!url) return null;
	if (/^https?:\/\//i.test(url)) return url;
	return `https://${url}`;
}

type QuickLinkInput = Partial<QuickLink> & { audienceGroupIds?: number[] };

export const adaptCreateQuickLinkPayload = (
	data: QuickLinkInput
): Partial<IQuickLink> & { audience_group_ids?: number[] } => {
	return {
		heading: data.heading,
		content: data.content ?? null,
		button_link: normalizeUrl(data.buttonLink),
		webview: data.webview ?? false,
		feed_id: data.feedId ?? null,
		audience_group_ids: data.audienceGroupIds ?? []
	};
};

export const adaptEditQuickLinkPayload = (
	data: QuickLinkInput
): Partial<IQuickLink> & { audience_group_ids?: number[] } => {
	return {
		id: data.id,
		heading: data.heading,
		content: data.content ?? null,
		button_link: normalizeUrl(data.buttonLink),
		webview: data.webview ?? false,
		feed_id: data.feedId ?? null,
		audience_group_ids: data.audienceGroupIds ?? []
	};
};
